import { render, staticRenderFns } from "./postModalCounters.vue?vue&type=template&id=7640f230&scoped=true&"
import script from "./postModalCounters.vue?vue&type=script&lang=js&"
export * from "./postModalCounters.vue?vue&type=script&lang=js&"
import style0 from "./postModalCounters.vue?vue&type=style&index=0&id=7640f230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7640f230",
  null
  
)

export default component.exports